module.exports = __webpack_public_path__ + "static/media/zoomAttendancePreviewImage.cc363b4d.png";